import { useEffect, useRef, useState } from "react";
import bg from "../../assets/bg.jpg";
import dp from "../../assets/dp_new.jpg";
import facebook from "../../assets/facebook.png";
import instagram from "../../assets/instagram.png";
import linkedin from "../../assets/linkedin.png";
import mail from "../../assets/mail.png";
import phone from "../../assets/phone.png";
import projectImage from "../../assets/project.png";
import { CircularProgress } from "../../components/circularProgress/CircularProgress";
import { LinearProgress } from "../../components/linearProgress/LinearProgress";
import { Projects } from "../../data/projects";
import { logAppEvent } from "../../modules/firebase";
import { isElementInViewport } from "../../utils/isElementInViewport";
import styles from "./Home.module.scss";

const DescriptionItem = (props) => {
  return (
    <div className={styles.item}>
      <div className={styles.itemCount}>{props.leftText}</div>
      <div className={styles.itemDesc}>{props.rightText}</div>
    </div>
  );
};

const ProjectCard = (props) => {
  const el = useRef();
  const isEffectAdded = useRef(false);
  const [progressStyle, setProgressStyle] = useState("");
  const intervalRef = useRef();

  useEffect(() => {
    const timeout = setTimeout(() => {
      intervalRef.current = setInterval(() => {
        checkVisibility();
      }, 250);
    }, 500);

    return () => {
      window.clearInterval(intervalRef.current);
      window.clearTimeout(timeout);
    };
  }, []);

  const checkVisibility = () => {
    if (!el || isEffectAdded.current) return;
    if (isElementInViewport(el.current)) {
      setProgressStyle(styles.visibleProjectCard);
      isEffectAdded.current = true;
      clearInterval(intervalRef.current);
    }
  };

  return (
    <div className={`${styles.projectCard} ${progressStyle}`}>
      <img src={projectImage} className={styles.projectCardImage} ref={el} />
      <div className={styles.projectCardText}>
        <div className={styles.projectCardName}>{props.title}</div>
        <div className={styles.projectCardHr} />
        <div className={styles.projectCardDescription}>{props.description}</div>
        <div className="grow" />
        {props.tools && props.tools.length > 0 && (
          <div className={styles.projectTools}>
            {props.tools.map((tool, index) => (
              <div className={styles.projectTool} key={index}>
                {tool}
              </div>
            ))}
          </div>
        )}
        <a className={styles.projectLink} href={props.link} target="_blank">
          {props.linkText}
        </a>
      </div>
    </div>
  );
};

const HomeContent = () => {
  return (
    <div className={styles.home}>
      <div className={styles.bgWrapper}>
        <img src={bg} className={styles.bg} />
        <div className={styles.bgOverlay}></div>
        <div className={styles.bgTexts}>
          <div className={styles.homeHeader}>Welcome To My Personal Space!</div>
          <div className={styles.codeSection}>
            <span className={styles.codeRed}>const</span>{" "}
            <span className={styles.codePurple}>printMyself</span>{" "}
            <span className={styles.codeRed}>=</span>
            <span className={styles.codeBlue}> ()</span>
            <span className={styles.codeRed}> {"=>"} </span>
            <span className={styles.codeBlue}>console</span>.
            <span className={styles.codePurple}>log</span>
            <span className={styles.codeGreen}>(</span>
            <span className={styles.codeBlue}>
              {`"Full-Stack Software Engineer with over ${
                new Date().getFullYear() - 2019
              } years of experience"`}
            </span>
            <span className={styles.codeGreen}>)</span>
          </div>
        </div>
      </div>
      <div className={styles.itemContainer}>
        <DescriptionItem
          leftText={`${new Date().getFullYear() - 2019}+`}
          rightText="Years of Experience"
        />
        <DescriptionItem leftText="12+" rightText="Projects" />
        <DescriptionItem leftText="7+" rightText="Happy Customers" />
      </div>
      <div className={styles.projectsContainer}>
        {Projects.map((project, index) => (
          <ProjectCard {...project} key={index} />
        ))}
      </div>
      {/* <ImageViewer /> */}
    </div>
  );
};

export function Home() {
  useEffect(() => {
    logAppEvent("view_home_page");
  }, []);
  // useEffect(() => {
  //   document.body.style.overflowY = "hidden";
  //   setTimeout(() => {
  //     document.body.style.overflowY = "auto";
  //   }, 1400);
  // }, []);
  return (
    <div className={styles.app}>
      <div className={styles.leftSection}>
        <div className={styles.personal}>
          <div className={styles.avatarContainer}>
            <img src={dp} className={styles.avatar} alt="Dinura Imesh Photo" />
          </div>
          <div className={styles.personalName}>Dinura Imesh</div>
          <div className={styles.personalDesc}>Full-Stack Engineer</div>
          <div className={styles.personalDesc2}>Turning ideas into reality</div>
          <div className={styles.mobileSocialIcons}>
            <a
              className={styles.aImg}
              href="https://www.facebook.com/dinura.imesh/"
              target="_blank"
            >
              <img
                src={facebook}
                className={styles.socialIcon}
                alt="facebook"
              />
            </a>
            <a
              className={styles.aImg}
              href="https://www.linkedin.com/in/dinura-imesh/"
              target="_blank"
            >
              <img
                src={linkedin}
                className={styles.socialIcon}
                alt="linkedin"
              />
            </a>
            <a
              className={styles.aImg}
              href="https://www.instagram.com/dinura.imesh/"
              target="_blank"
            >
              <img
                src={instagram}
                className={styles.socialIcon}
                alt="instagram"
              />
            </a>
            <a
              className={styles.aImg}
              href="mailto:dinuraimesh@gmail.com"
              target="_blank"
            >
              <img src={mail} className={styles.socialIcon} alt="email" />
            </a>
            <a className={styles.aImg} href="tel:+94766761753" target="_blank">
              <img src={phone} className={styles.socialIcon} alt="phone" />
            </a>
          </div>
        </div>
        <div className={styles.skillsContainer}>
          <div className={styles.personalInfoContainer}>
            <div className={styles.personalInfo}>
              <div>Residence</div>
              <div className={styles.personalInfoValue}>Sri Lanka</div>
            </div>
            <div className={styles.personalInfo}>
              <div>City</div>
              <div className={styles.personalInfoValue}>Ja-Ela</div>
            </div>
            <div className={styles.personalInfo}>
              <div>Age</div>
              <div className={styles.personalInfoValue}>
                {Math.floor(new Date().getFullYear() - 1999)}
              </div>
            </div>
            <div className={styles.hr}></div>
          </div>
          <div className={styles.coreSkills}>
            <div className={styles.coreSkill}>
              <CircularProgress progress="95" />
              <div className={styles.coreSkillName}>ReactJS</div>
            </div>
            <div className={styles.coreSkill}>
              <CircularProgress progress="95" />
              <div className={styles.coreSkillName}>ExpressJS</div>
            </div>
            <div className={styles.coreSkill}>
              <CircularProgress progress="90" />
              <div className={styles.coreSkillName}>CSS/SASS</div>
            </div>
            <div className={styles.coreSkill}>
              <CircularProgress progress="90" />
              <div className={styles.coreSkillName}>Typescript</div>
            </div>
          </div>
          <div className={styles.skills}>
            <LinearProgress text="NodeJS" progress="95" />
            <LinearProgress text="HTML" progress="95" />
            <LinearProgress text="Electron" progress="90" />
            <LinearProgress text="MongoDB/SQL" progress="85" />
            <LinearProgress text="Unity3D" progress="80" />
            <LinearProgress text="Flutter" progress="75" />
            <LinearProgress text="PHP" progress="60" />
            <LinearProgress text="AWS" progress="50" />
          </div>
        </div>
        <div className={styles.socialIcons}>
          <a
            className={styles.aImg}
            href="https://www.facebook.com/dinura.imesh/"
            target="_blank"
          >
            <img src={facebook} className={styles.socialIcon} alt="facebook" />
          </a>
          <a
            className={styles.aImg}
            href="https://www.linkedin.com/in/dinura-imesh/"
            target="_blank"
          >
            <img src={linkedin} className={styles.socialIcon} alt="linkedin" />
          </a>
          <a
            className={styles.aImg}
            href="https://www.instagram.com/dinura.imesh/"
            target="_blank"
          >
            <img
              src={instagram}
              className={styles.socialIcon}
              alt="instagram"
            />
          </a>
          <a
            className={styles.aImg}
            href="mailto:dinuraimesh@gmail.com"
            target="_blank"
          >
            <img src={mail} className={styles.socialIcon} alt="email" />
          </a>
          <a className={styles.aImg} href="tel:+94766761753" target="_blank">
            <img src={phone} className={styles.socialIcon} alt="phone" />
          </a>
        </div>
      </div>
      <div className={styles.rightSection}>
        <HomeContent />
      </div>
      {/* <div className={styles.mobileSocialIcons}>
        <a
          className={styles.aImg}
          href="https://www.facebook.com/dinura.imesh/"
          target="_blank"
        >
          <img src={facebook} className={styles.socialIcon} alt="facebook" />
        </a>
        <a
          className={styles.aImg}
          href="https://www.linkedin.com/in/dinura-imesh/"
          target="_blank"
        >
          <img src={linkedin} className={styles.socialIcon} alt="linkedin" />
        </a>
        <a
          className={styles.aImg}
          href="https://www.instagram.com/dinura.imesh/"
          target="_blank"
        >
          <img src={instagram} className={styles.socialIcon} alt="instagram" />
        </a>
        <a
          className={styles.aImg}
          href="mailto:dinuraimesh@gmail.com"
          target="_blank"
        >
          <img src={mail} className={styles.socialIcon} alt="email" />
        </a>
        <a className={styles.aImg} href="tel:+94766761753" target="_blank">
          <img src={phone} className={styles.socialIcon} alt="phone" />
        </a>
      </div> */}
      {/* <div className={styles.welcomeOverlay}>
        <div>WELCOME</div>
      </div> */}
    </div>
  );
}
